(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizzo-lifeware"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rizzo-lifeware')) {
  customElements.define('rizzo-lifeware', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.scenes = [...this.querySelectorAll('[data-scene]')];
      this.stage = this.querySelector('.rzlw2__stage');
      this.photo = this.querySelector('.rzlw2__photo');
      this.film = this.querySelector('[data-film]');
      this.nav = this.querySelector('.rzlw2__nav');
      this.exit = this.querySelector('[data-exit]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.nav.replaceChildren();
      this.buttons = this.scenes.map((scene, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', scene.dataset.chapter);
        button.addEventListener('click', () => this.go(index), {signal});
        this.nav.append(button);
        return button;
      });

      // Tek dokunuşla bölümden çık: başa ışınla, aradaki ekranları geri kaydırma.
      if (this.exit) this.exit.addEventListener('click', () => {
        const start = this.getBoundingClientRect().top + window.scrollY;
        // hikâyenin biraz üstüne bırak: çıktığı anlaşılsın
        const target = Math.max(0, start - window.innerHeight * 0.35);
        window.scrollTo({top: target, behavior: 'instant'});
      }, {signal});

      // Film: kaydırma karesi sürüyor. iOS'ta arama için önce hazırlanması gerekiyor.
      if (this.film) {
        this.film.addEventListener('loadedmetadata', () => {this.filmReady = true; this.paint();}, {signal});
        const prime = () => {
          const p = this.film.play();
          if (p && p.then) p.then(() => this.film.pause()).catch(() => {});
          else this.film.pause();
        };
        this.film.addEventListener('loadeddata', prime, {once: true, signal});
        document.addEventListener('touchstart', prime, {once: true, passive: true, signal});
      }

      this.measure = () => {
        const shortScreen = innerHeight < 560 && innerWidth < 800;
        const enlargedText = parseFloat(getComputedStyle(document.documentElement).fontSize) > 22;
        this.enabled = !this.reduced.matches && !shortScreen && !enlargedText;
        this.classList.toggle('is-ready', this.enabled);
        const tempo = this.dataset.tempo === 'compact' ? .5 : this.dataset.tempo === 'roomy' ? .85 : .65;
        this.step = this.stage.clientHeight * tempo;
        this.style.setProperty('--lw-height', `${this.stage.clientHeight + this.step * (this.scenes.length - 1) + this.step * .2}px`);
        this.paint();
      };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.paint(); });
      };
      window.addEventListener('scroll', this.schedule, {passive:true, signal});
      window.addEventListener('resize', this.measure, {passive:true, signal});
      this.reduced.addEventListener('change', this.measure, {signal});
      document.addEventListener('shopify:block:select', event => {
        const target = this.scenes.findIndex(scene => scene === event.target || scene.contains(event.target));
        if (target >= 0) this.go(target, true);
      }, {signal});
      this.measure();
    }
    go(index, instant = false) {
      const y = this.getBoundingClientRect().top + window.scrollY + index * this.step;
      if (this.enabled) window.scrollTo({top:y, behavior:instant || this.reduced.matches ? 'instant' : 'smooth'});
      else this.scenes[index].scrollIntoView({block:'center', behavior:'instant'});
    }
    paint() {
      if (!this.scenes) return;
      if (!this.enabled) {
        this.scenes.forEach(scene => {scene.style.opacity = '';scene.style.transform = '';scene.removeAttribute('aria-hidden');scene.inert = false;});
        if (this.exit) this.exit.hidden = true;
        return;
      }
      const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
      const position = clamp(-this.getBoundingClientRect().top / this.step, 0, this.scenes.length - 1);
      const index = Math.floor(position);
      const fraction = position - index;
      const t = clamp((fraction - .4) / .6, 0, 1);
      const eased = t * t * (3 - 2 * t);
      const active = clamp(index + (t >= .5 ? 1 : 0), 0, this.scenes.length - 1);
      this.scenes.forEach((scene, i) => {
        let opacity = 0, y = 30;
        if (i === index) {opacity = 1 - eased;y = -eased * 22;}
        if (i === index + 1) {opacity = eased;y = (1 - eased) * 30;}
        scene.style.opacity = opacity;
        scene.style.transform = `translate3d(0,${y}vh,0)`;
        scene.style.pointerEvents = i === active ? 'auto' : 'none';
        scene.setAttribute('aria-hidden', String(i !== active));
        scene.inert = i !== active;
        this.buttons[i].setAttribute('aria-current', String(i === active));
      });
      const progress = position / (this.scenes.length - 1);
      if (this.film && this.filmReady && this.film.duration) {
        const target = progress * this.film.duration;
        if (Math.abs(this.film.currentTime - target) > .02) this.film.currentTime = target;
      } else if (this.photo) {
        const next = this.scenes[Math.min(index + 1, this.scenes.length - 1)];
        const startZoom = Number(this.scenes[index].dataset.zoom);
        const zoom = startZoom + (Number(next.dataset.zoom) - startZoom) * eased;
        this.photo.style.transform = `scale(${zoom})`;
      }
      if (this.exit) this.exit.hidden = active < 1;
      this.style.setProperty('--lw-progress', progress);
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
